import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["xlink:href", "height", "width"]
const _hoisted_4 = ["points", "onClick"]
const _hoisted_5 = { class: "body-2 pt-1" }
const _hoisted_6 = { class: "body-2" }
const _hoisted_7 = { class: "body-2 pt-1" }
const _hoisted_8 = { class: "body-2" }
const _hoisted_9 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_10 = ["viewBox"]
const _hoisted_11 = ["xlink:href", "height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_upload_documents = _resolveComponent("upload-documents")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-1",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100vw;' : '')
  }, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "7",
                  class: "pr-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DocumentMenu, {
                          MenuOptions: _ctx.documentMenuOptions,
                          onZoomIn: _cache[0] || (_cache[0] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                          onResetZoom: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                          onZoomOut: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                          onRotateLeft: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.documentPdfRotation = _ctx.rotate(
                                    'left',
                                    _ctx.zoomManager,
                                    _ctx.documentPdfRotation,
                                )
                            )),
                          onRotateRight: _cache[4] || (_cache[4] = ($event: any) => (
                                _ctx.documentPdfRotation = _ctx.rotate(
                                    'right',
                                    _ctx.zoomManager,
                                    _ctx.documentPdfRotation,
                                )
                            )),
                          onDownload: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startDownloadFile())),
                          onDelete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                        }, null, 8, ["MenuOptions"]),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            (_ctx.isPDF)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12",
                                  class: "d-flex justify-center",
                                  style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ossPdf, {
                                      documentId: _ctx.document.id
                                    }, null, 8, ["documentId"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12",
                                  style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                      (_ctx.document)
                                        ? (_openBlock(), _createElementBlock("svg", {
                                            key: 0,
                                            id: "svg-document-to-reupload",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "100%",
                                            viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                            style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                          }, [
                                            _createElementVNode("g", null, [
                                              _createElementVNode("image", {
                                                id: "svg-image-document-to-reupload",
                                                "xlink:href": _ctx.document.signedUrl,
                                                x: "0",
                                                y: "0",
                                                height: `${_ctx.imageHeight}px`,
                                                width: `${_ctx.imageWidth}px`
                                              }, null, 8, _hoisted_3),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgVariants, (variant, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: `coord-${_ctx.document.id}-${index}`
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                                    return (_openBlock(), _createElementBlock("polygon", {
                                                      key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                                      ref_for: true,
                                                      ref: `variants-${index}-${index2}`,
                                                      points: _ctx.getPoints(coord),
                                                      style: _normalizeStyle(
                                                            variant.active
                                                                ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                        ),
                                                      onClick: _withModifiers(($event: any) => (
                                                            variant.active
                                                                ? ''
                                                                : _ctx.showCorrespondingField({
                                                                      variant,
                                                                      currentIndex: index,
                                                                      copyIndex: index2,
                                                                  })
                                                        ), ["stop"]),
                                                      class: _normalizeClass(variant.focus ? 'highlighted' : '')
                                                    }, null, 14, _hoisted_4))
                                                  }), 128))
                                                ], 64))
                                              }), 128))
                                            ])
                                          ], 8, _hoisted_2))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.associatedFields.show)
                      ? (_openBlock(), _createBlock(_component_v_list, {
                          key: 0,
                          style: _normalizeStyle(_ctx.svgPosition)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: `field-${_ctx.document.id}-${key}-${index}`,
                                onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                                class: "oss-list-item"
                              }, null, 8, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["style"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "my-0 pl-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"auto"},
                      class: "default_card_wm elevation-0 rounded-l-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.windowStep,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.windowStep) = $event)),
                          touchless: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { step: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_form, {
                                      ref: "form",
                                      modelValue: _ctx.valid,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.valid) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list, {
                                                  "single-line": "",
                                                  class: "pt-2 pb-0",
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, {
                                                      ripple: false,
                                                      class: "mb-2",
                                                      color: "success"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_row, {
                                                              "no-gutters": "",
                                                              class: "align-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                  cols: "3",
                                                                  style: {"border-right":"1px #ededed\n                                                                            solid"}
                                                                }, {
                                                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                                    _createElementVNode("b", null, "Statut", -1)
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, {
                                                                  cols: "9",
                                                                  class: "pl-2 d-flex justify-space-between align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.documentStatus), 1)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item, {
                                                      clmass: "oss-list-item",
                                                      ripple: false,
                                                      class: "mb-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_row, {
                                                              "no-gutters": "",
                                                              class: "align-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                  cols: "3",
                                                                  style: {"border-right":"1px #ededed\n                                                                            solid"}
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.thirdPartyType()), 1)
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, {
                                                                  cols: "9",
                                                                  class: "pl-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("div", null, _toDisplayString(_ctx.document.thirdPartyCompany
                                                                                ? _ctx.document
                                                                                      .thirdPartyCompany
                                                                                      .name
                                                                                : ""), 1),
                                                                    _createElementVNode("div", _hoisted_5, " Siret : " + _toDisplayString(_ctx.document.thirdPartyCompany &&
                                                                            _ctx.document
                                                                                .thirdPartyCompany
                                                                                .siret
                                                                                ? _ctx.getSiretValue(
                                                                                      _ctx.document
                                                                                          .thirdPartyCompany
                                                                                          .siret,
                                                                                  )
                                                                                : ""), 1),
                                                                    _createElementVNode("div", _hoisted_6, " Adresse : " + _toDisplayString(_ctx.fullAddress), 1)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list, {
                                                  "single-line": "",
                                                  class: "py-0",
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, {
                                                      ripple: false,
                                                      class: "oss-list-item my-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_row, {
                                                              "no-gutters": "",
                                                              class: "align-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                  cols: "3",
                                                                  class: "d-flex align-center",
                                                                  style: {"border-right":"1px #ededed\n                                                                            solid","height":"28px"}
                                                                }, {
                                                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                                    _createElementVNode("b", null, "Type", -1)
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, {
                                                                  cols: "9",
                                                                  class: "pl-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.formatCategory(
                                                                            _ctx.document.type,
                                                                        )), 1)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    (_ctx.document.createdAt)
                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: 0,
                                                          ripple: false,
                                                          class: "my-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_row, {
                                                                  "no-gutters": "",
                                                                  class: "align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "3",
                                                                      class: "d-flex align-center",
                                                                      style: {"border-right":"1px #ededed\n                                                                            solid","height":"28px"}
                                                                    }, {
                                                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                                        _createElementVNode("b", null, "Importer le ", -1)
                                                                      ])),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "9",
                                                                      class: "pl-2"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.formatDate(
                                                                            _ctx.document.createdAt,
                                                                        )), 1)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.dueDateEnable)
                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: 1,
                                                          ripple: false,
                                                          class: "my-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_row, {
                                                                  "no-gutters": "",
                                                                  class: "align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "3",
                                                                      class: "d-flex align-center",
                                                                      style: {"border-right":"1px #ededed\n                                                                            solid","height":"28px"}
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t("shared.dueDate")), 1)
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "9",
                                                                      class: "pl-2"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_oss_date_picker_filled, {
                                                                          "model-value": _ctx.dueDate,
                                                                          onChangeDate: 
                                                                            _ctx.onDueDateChanged
                                                                        ,
                                                                          textFieldReadOnly: false,
                                                                          hideDetails: true
                                                                        }, null, 8, ["model-value", "onChangeDate"])
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.document.vatType)
                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: 2,
                                                          ripple: false,
                                                          class: "my-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_row, {
                                                                  "no-gutters": "",
                                                                  class: "align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "3",
                                                                      class: "d-flex align-center",
                                                                      style: {"border-right":"1px #ededed\n                                                                            solid","height":"28px"}
                                                                    }, {
                                                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                                        _createElementVNode("b", null, "Type de TVA", -1)
                                                                      ])),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "9",
                                                                      class: "pl-2"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t(
                                                                            `document.vatType.${_ctx.document.vatType}`,
                                                                        )), 1)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_upload_documents, {
                                                  showFirstPrevious: false,
                                                  showBtns: true,
                                                  companyId: _ctx.companyId,
                                                  documentId: _ctx.documentId,
                                                  multiple: false,
                                                  freeTag: false,
                                                  hideTitle: true,
                                                  onFileUploaded: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reuploaded()))
                                                }, null, 8, ["companyId", "documentId"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                (
                                                        _ctx.document.type === 'PURCHASE_INVOICE' ||
                                                        _ctx.document.type === 'SALES_INVOICE' ||
                                                        _ctx.document.type === 'EXPENSE_REPORT_DOCUMENT'
                                                    )
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 0,
                                                      elevation: "0",
                                                      rounded: "",
                                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.switchToDocumentValidation())),
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                        _createTextVNode(" Passer à la validation ")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.mode != 'GeneralLedger')
                          ? (_openBlock(), _createBlock(_component_v_card_actions, {
                              key: 0,
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_prev, {
                                  disabled: _ctx.previousDisabled(),
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.previous()))
                                }, null, 8, ["disabled"]),
                                _createVNode(_component_v_btn_next, {
                                  disabled: _ctx.nextDisabled(),
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.next()))
                                }, null, 8, ["disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.dialogChooseDownload,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
              title: "Télécharger le document",
              width: "800px"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          rounded: "",
                          block: "",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(true);
                                }),
                          size: "x-large"
                        }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createTextVNode("Original")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          rounded: "",
                          block: "",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(false);
                                }),
                          size: "x-large"
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode("Marqué")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _cache[29] || (_cache[29] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.deleteDocumentDialog,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
              title: "Supprimer le document",
              error: true,
              onValid: _ctx.deleteDocument,
              validTitle: 'Oui je suis sûr(e)',
              validLoading: _ctx.deleteDocumentLoading,
              width: "800px"
            }, {
              default: _withCtx(() => _cache[30] || (_cache[30] = [
                _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir supprimer le document ? ", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "onValid", "validLoading"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.editDialog,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editDialog) = $event)),
              title: "Editer le document",
              onValid: _ctx.editDocument,
              validTitle: 'Oui je suis sûr(e)',
              validLoading: _ctx.editLoading,
              width: "800px"
            }, {
              default: _withCtx(() => _cache[31] || (_cache[31] = [
                _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir éditer le document ?", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "onValid", "validLoading"]),
            (_ctx.openChat)
              ? (_openBlock(), _createBlock(_component_Chat, {
                  key: 0,
                  id: _ctx.document.chat ? _ctx.document.chat.id : '',
                  status: 'INFORMATION_REQUEST'
                }, null, 8, ["id"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.showDocument,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showDocument) = $event)),
                    "hide-details": "",
                    label: "Afficher le document",
                    class: "my-0 py-0"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.step,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.step) = $event)),
                    class: "fill-height"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_layout, { wrap: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_flex, { xs12: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_form, {
                                    ref: "form",
                                    modelValue: _ctx.valid,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.valid) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, {
                                                "single-line": "",
                                                class: "py-0",
                                                style: {"background":"transparent"},
                                                density: "compact"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    ripple: false,
                                                    class: "mb-2 px-1",
                                                    color: "success"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "align-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                cols: "3",
                                                                style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px"}
                                                              }, {
                                                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                                  _createElementVNode("b", null, "Statut", -1)
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_v_col, {
                                                                cols: "9",
                                                                class: "pl-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(_ctx.documentStatus) + " ", 1),
                                                                  _createVNode(_component_v_spacer),
                                                                  (
                                                                            _ctx.reconciliationCallToAction
                                                                        )
                                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                        key: 0,
                                                                        rounded: "",
                                                                        elevation: "0",
                                                                        disabled: 
                                                                            _ctx.disabledCallToAction
                                                                        ,
                                                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (
                                                                            _ctx.openReconciliation()
                                                                        )),
                                                                        size: "x-small"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode(_toDisplayString(_ctx.reconciliationCallToAction), 1)
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["disabled"]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, {
                                                    ripple: false,
                                                    class: "oss-list-item mb-2 px-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "align-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                cols: "3",
                                                                style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px"}
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("b", null, _toDisplayString(_ctx.thirdPartyType()), 1)
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_v_col, {
                                                                cols: "9",
                                                                class: "pl-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("div", null, _toDisplayString(_ctx.document.thirdPartyCompany
                                                                                ? _ctx.document
                                                                                      .thirdPartyCompany
                                                                                      .name
                                                                                : ""), 1),
                                                                  _createElementVNode("div", _hoisted_7, " Siret : " + _toDisplayString(_ctx.document.thirdPartyCompany &&
                                                                            _ctx.document
                                                                                .thirdPartyCompany
                                                                                .siret
                                                                                ? _ctx.getSiretValue(
                                                                                      _ctx.document
                                                                                          .thirdPartyCompany
                                                                                          .siret,
                                                                                  )
                                                                                : ""), 1),
                                                                  _createElementVNode("div", _hoisted_8, " Adresse : " + _toDisplayString(_ctx.fullAddress), 1)
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (
                                                            _ctx.activateTagguing &&
                                                            _ctx.document.type !==
                                                                'EXPENSE_REPORT_DOCUMENT'
                                                        )
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 0,
                                                        ripple: false,
                                                        class: "mb-2 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_FreeTag, {
                                                                        companyTags: 
                                                                            _ctx.allCompanyTags
                                                                        ,
                                                                        document: _ctx.inDocument,
                                                                        onChanged: 
                                                                            _ctx.startToBeDoneIfNecessary
                                                                        
                                                                      }, null, 8, ["companyTags", "document", "onChanged"])
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (
                                                    _ctx.isAccountingUser &&
                                                    _ctx.currentUser.profile.configuration.accounting
                                                        .write &&
                                                    _ctx.currentUser.profile.configuration.document.write
                                                )
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.subNetAmounts.length <= 1)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        (
                                                            !_ctx.multiVat &&
                                                            _ctx.document.type !== 'BANK_CHARGE' &&
                                                            _ctx.document.type !== 'WITHOUT_INVOICE'
                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 0,
                                                              "no-gutters": "",
                                                              class: "pt-2 flex-grow-1 flex-shrink-0"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_AccountableAccountVue, {
                                                                      companyId: _ctx.companyId,
                                                                      document: _ctx.document,
                                                                      inputStyle: 'padding: 0px; margin: 0px;',
                                                                      showSuggestion: false,
                                                                      showDescription: true,
                                                                      showValidation: false,
                                                                      mandatory: false,
                                                                      hideDetails: true,
                                                                      onClose: _ctx.closeAccountableAccount,
                                                                      onSelectAccountableAccount: 
                                                                    _ctx.selectAccountableAccount
                                                                
                                                                    }, null, 8, ["companyId", "document", "onClose", "onSelectAccountableAccount"])
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    : (_openBlock(), _createBlock(_component_v_card, {
                                                        key: 1,
                                                        class: "default_card_wm mx-auto",
                                                        style: {"background":"#fff !important","box-shadow":"none"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, { cols: "1Z" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_chip_group, null, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNetAmounts, (item, index) => {
                                                                        return (_openBlock(), _createBlock(_component_v_chip, {
                                                                          label: "",
                                                                          key: index,
                                                                          size: "small",
                                                                          variant: "outlined"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(item.accountableAccount
                                                                                .name) + " (" + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                item.netAmountSigned,
                                                                                undefined,
                                                                            )) + ") ", 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, {
                                                "single-line": "",
                                                style: {"background":"transparent"},
                                                class: "py-0",
                                                density: "compact"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    ripple: false,
                                                    class: "oss-list-item mb-2 px-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "align-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                cols: "4",
                                                                style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px","height":"28px"}
                                                              }, {
                                                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                                  _createElementVNode("b", null, "Type", -1)
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_v_col, {
                                                                cols: "8",
                                                                class: "pl-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(_ctx.formatCategory(
                                                                            _ctx.document.type,
                                                                        )), 1)
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (_ctx.document.date)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 0,
                                                        ripple: false,
                                                        class: "mb-2 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, {
                                                                "no-gutters": "",
                                                                class: "align-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "4",
                                                                    style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px","height":"28px"}
                                                                  }, {
                                                                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                                      _createElementVNode("b", null, "Date", -1)
                                                                    ])),
                                                                    _: 1
                                                                  }),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "8",
                                                                    class: "pl-2"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.document.date)), 1)
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.dueDateEnable)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 1,
                                                        ripple: false,
                                                        class: "mb-2 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, {
                                                                "no-gutters": "",
                                                                class: "align-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "4",
                                                                    style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px","height":"28px"}
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("shared.dueDate")), 1)
                                                                    ]),
                                                                    _: 1
                                                                  }),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "8",
                                                                    class: "pl-2"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_oss_date_picker_filled, {
                                                                        "model-value": _ctx.dueDate,
                                                                        onChangeDate: 
                                                                            _ctx.onDueDateChanged
                                                                        ,
                                                                        textFieldReadOnly: false,
                                                                        hideDetails: true
                                                                      }, null, 8, ["model-value", "onChangeDate"])
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.document.vatType)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 2,
                                                        ripple: false,
                                                        class: "mb-2 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, {
                                                                "no-gutters": "",
                                                                class: "align-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "4",
                                                                    style: {"border-right":"solid\n                                                                            rgba(0, 0, 0, 0.12) 1px","height":"28px"}
                                                                  }, {
                                                                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                                      _createElementVNode("b", null, "Type de TVA", -1)
                                                                    ])),
                                                                    _: 1
                                                                  }),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "8",
                                                                    class: "pl-2"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.$t(
                                                                            `document.vatType.${_ctx.document.vatType}`,
                                                                        )), 1)
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, {
                                                "no-gutters": "",
                                                class: "align-center py-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { class: "col-auto pr-3" }, {
                                                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                                                      _createTextVNode(" Détails ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_divider)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_data_table, {
                                                headers: _ctx.headers,
                                                items: _ctx.prices,
                                                "hide-default-footer": "",
                                                "hide-default-header": "",
                                                class: "table",
                                                style: {"border":"1px #ededed solid"}
                                              }, {
                                                header: _withCtx(() => [
                                                  _createElementVNode("tr", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                                                      return (_openBlock(), _createElementBlock("td", {
                                                        key: index,
                                                        class: "text-center py-2"
                                                      }, _toDisplayString(header.text), 1))
                                                    }), 128))
                                                  ])
                                                ]),
                                                item: _withCtx(({ item }) => [
                                                  _createElementVNode("tr", null, [
                                                    _createElementVNode("td", {
                                                      class: _normalizeClass(
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                )
                                                    }, _toDisplayString(item.accountableAccount !== null
                                                                        ? item.accountableAccount
                                                                        : "-"), 3),
                                                    _createElementVNode("td", {
                                                      class: _normalizeClass(
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                )
                                                    }, _toDisplayString(item.netAmountSigned !== null
                                                                        ? _ctx.newCommonFormatCurrency(
                                                                              item.netAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"), 3),
                                                    _createElementVNode("td", {
                                                      class: _normalizeClass(
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                )
                                                    }, _toDisplayString(item.vatRate !== null
                                                                        ? item.vatRate + "%"
                                                                        : "-"), 3),
                                                    _createElementVNode("td", {
                                                      class: _normalizeClass(
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                )
                                                    }, _toDisplayString(item.vatAmountSigned !== null
                                                                        ? _ctx.newCommonFormatCurrency(
                                                                              item.vatAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"), 3),
                                                    _createElementVNode("td", {
                                                      class: _normalizeClass(
                                                                    item.total
                                                                        ? 'text-center font-weight-bold'
                                                                        : 'text-center font-weight-regular'
                                                                )
                                                    }, _toDisplayString(item.grossAmountSigned !== null
                                                                        ? _ctx.newCommonFormatCurrency(
                                                                              item.grossAmountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"), 3)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["headers", "items"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                style: {"max-height":"85vh","overflow-y":"auto"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    (_ctx.document)
                                      ? (_openBlock(), _createElementBlock("svg", {
                                          key: 0,
                                          id: "svg-document-validation",
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "100%",
                                          viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                          style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                        }, [
                                          _createElementVNode("image", {
                                            id: "svg-image-document-validation",
                                            "xlink:href": _ctx.document.signedUrl,
                                            x: "0",
                                            y: "0",
                                            height: `${_ctx.imageHeight}px`,
                                            width: `${_ctx.imageWidth}px`
                                          }, null, 8, _hoisted_11)
                                        ], 8, _hoisted_10))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["style"]))
}